import { computed } from "vue";
import zakat from "~/data/zakat.json";

type NisabType = "silver" | "gold";

type MetalRates = {
  goldPerTola: number;
  silverPerTola: number;
  goldNisabPKR: number;
  silverNisabPKR: number;
  lastUpdated: string;
  defaultNisab: NisabType;
};

const TOLA_IN_GRAMS = 11.664;

export function useMetal() {
  const metalRates = computed<MetalRates>(() => {
    const goldPerGram = Number(zakat.gold);
    const silverPerGram = Number(zakat.silver);

    const goldPerTola = Math.round(goldPerGram * TOLA_IN_GRAMS);
    const silverPerTola = Math.round(silverPerGram * TOLA_IN_GRAMS);
    const defaultNisab: NisabType = zakat.nisab === "gold" ? "gold" : "silver";

    return {
      goldPerTola,
      silverPerTola,
      goldNisabPKR: Math.round(goldPerTola * 7.5),
      silverNisabPKR: Math.round(silverPerTola * 52.5),
      lastUpdated: zakat.lastUpdated,
      defaultNisab,
    };
  });

  return { metalRates };
}
